import _defineProperty from "C:\\Executables\\Raindeers\\ClaimsHub\\frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _Array$isArray from "@babel/runtime-corejs3/core-js-stable/array/is-array";
import _someInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/some";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import { useMemo } from 'react';
import { useLocation, matchPath } from 'react-router-dom';
import { isFloorPlanOverride, isFloorPlanDefault } from './helpers';
export default function useFloorPlanMatch(floorPlans) {
  var location = useLocation();

  var _useMemo = useMemo(function () {
    return [_findInstanceProperty(floorPlans).call(floorPlans, isFloorPlanDefault), _filterInstanceProperty(floorPlans).call(floorPlans, isFloorPlanOverride)];
  }, [floorPlans]),
      _useMemo2 = _slicedToArray(_useMemo, 2),
      defaultFloorPlan = _useMemo2[0],
      floorPlanOverrides = _useMemo2[1];

  return useMemo(function () {
    var matchedFloorplanOverride = _findInstanceProperty(floorPlanOverrides).call(floorPlanOverrides, function (_ref) {
      var matches = _ref.matches;

      var _context;

      return _someInstanceProperty(_context = _Array$isArray(matches) ? matches : [matches]).call(_context, function (pathMatch) {
        return matchPath(location.pathname, pathMatch);
      });
    });

    return _objectSpread({}, defaultFloorPlan, {}, matchedFloorplanOverride);
  }, [defaultFloorPlan, floorPlanOverrides, location.pathname]);
}